import Learning from './pages/Learning'
import Bookmarks from './pages/Bookmarks'
import NetworkActivity from './pages/NetworkActivity'
import UserContent from './pages/UserContent'
import { RouteNames } from 'constants/routeNames'
import { Route } from '../../constants/types'

export const routes: Route[] = [
  {
    key: 'MYATD_ACTIVITYHISTORY_LEARNING',
    type: 'private',
    title: 'Learning',
    path: `/${RouteNames.MYATD}/${RouteNames.ACTIVITY_HISTORY}/${RouteNames.LEARNING}`,
    component: Learning,
    exact: true,
  },
  {
    key: 'MYATD_ACTIVITYHISTORY_BOOKMARKS',
    type: 'private',
    title: 'Bookmarks',
    path: `/${RouteNames.MYATD}/${RouteNames.ACTIVITY_HISTORY}/${RouteNames.BOOKMARKS}`,
    component: Bookmarks,
    exact: true,
  },
  {
    key: 'MYATD_ACTIVITYHISTORY_NETWORKACTIVITY',
    type: 'private',
    title: 'Network Activity',
    path: `/${RouteNames.MYATD}/${RouteNames.ACTIVITY_HISTORY}/${RouteNames.NETWORK_ACTIVITY}`,
    component: NetworkActivity,
    exact: true,
  },
  {
    key: 'MYATD_ACTIVITYHISTORY_USERCONTENT',
    type: 'private',
    title: 'Contributions',
    path: `/${RouteNames.MYATD}/${RouteNames.ACTIVITY_HISTORY}/${RouteNames.USER_CONTENT}`,
    component: UserContent,
    exact: true,
    isHidden: (user: {
      isContributor: boolean
      visibility: {
        publicProfile: boolean
      }
    }) => {
      return !user?.visibility?.publicProfile || !user?.isContributor
    },
  },
]
const exportedRoutes = { routes }
export default exportedRoutes
